/**
 * @generated SignedSource<<396b91e552dabde0f100ec40de5e2fd2>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type modelGeneration3DModelsQuery$variables = Record<PropertyKey, never>;
export type modelGeneration3DModelsQuery$data = {
  readonly modelGeneration3DModels: ReadonlyArray<{
    readonly isDefault: boolean;
    readonly maxPromptLength: number;
    readonly model: string;
    readonly modelName: string;
    readonly serviceIDs: ReadonlyArray<number>;
    readonly slots: ReadonlyArray<string>;
    readonly supportedModes: ReadonlyArray<string>;
    readonly supportedParameters: ReadonlyArray<{
      readonly allowedValues: ReadonlyArray<string>;
      readonly defaultValue: string | null;
      readonly isRequired: boolean;
      readonly maxValue: number | null;
      readonly minValue: number | null;
      readonly name: string;
      readonly supportedModes: ReadonlyArray<string>;
      readonly type: string;
    }>;
  }>;
};
export type modelGeneration3DModelsQuery = {
  response: modelGeneration3DModelsQuery$data;
  variables: modelGeneration3DModelsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "supportedModes",
  "storageKey": null
},
v1 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "ModelGeneration3DModelInfo",
    "kind": "LinkedField",
    "name": "modelGeneration3DModels",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "serviceIDs",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "model",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "modelName",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "maxPromptLength",
        "storageKey": null
      },
      (v0/*:: as any*/),
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "slots",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "isDefault",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "ModelGeneration3DParameterInfo",
        "kind": "LinkedField",
        "name": "supportedParameters",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "name",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "type",
            "storageKey": null
          },
          (v0/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isRequired",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "defaultValue",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "allowedValues",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "minValue",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "maxValue",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "modelGeneration3DModelsQuery",
    "selections": (v1/*:: as any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "modelGeneration3DModelsQuery",
    "selections": (v1/*:: as any*/)
  },
  "params": {
    "cacheID": "08830479f0d1598c4de035762e085694",
    "id": null,
    "metadata": {},
    "name": "modelGeneration3DModelsQuery",
    "operationKind": "query",
    "text": "query modelGeneration3DModelsQuery {\n  modelGeneration3DModels {\n    serviceIDs\n    model\n    modelName\n    maxPromptLength\n    supportedModes\n    slots\n    isDefault\n    supportedParameters {\n      name\n      type\n      supportedModes\n      isRequired\n      defaultValue\n      allowedValues\n      minValue\n      maxValue\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "d40c1a5902be062c2bd4b2ff672c2a1b";

export default node;
